import { httpClient } from "./httpClient";

const base = "/api/menciones-honor";

const getAuthHeader = () => {
  const token = typeof localStorage !== "undefined" ? localStorage.getItem("token") : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const buildSafeName = (value) => {
  const raw = String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
  return raw || "menciones";
};

const getDownloadFilename = (res, fallbackName) => {
  const disposition = res.headers.get("content-disposition") || "";
  const match = disposition.match(/filename="?([^"]+)"?/i);
  if (match && match[1]) return match[1];
  return fallbackName || "documento.pdf";
};

export const generarMencionHonorPorMatricula = (matriculaId, modo = "SINGLE") =>
  httpClient.post(`${base}/matricula/${matriculaId}`, { modo });

export const generarMencionesHonorBatch = (matriculaIds, modo = "TWO_UP") =>
  httpClient.post(`${base}/batch`, { matricula_ids: matriculaIds, modo });

export const descargarMencionHonorPorMatricula = async (matriculaId) => {
  const url = `${httpClient.baseUrl}${base}/matricula/${matriculaId}?t=${Date.now()}`;
  const res = await fetch(url, {
    method: "GET",
    headers: {
      ...getAuthHeader(),
      Accept: "application/pdf",
    },
    cache: "no-store",
  });

  if (!res.ok) {
    let message = res.statusText || "No se pudo descargar la mencion.";
    const ct = res.headers.get("content-type") || "";
    try {
      if (ct.includes("application/json")) {
        const data = await res.json();
        if (data?.message) message = data.message;
      } else {
        const text = await res.text();
        if (text) message = text;
      }
    } catch {
      // ignore parse errors
    }
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }

  const blob = await res.blob();
  const filename = getDownloadFilename(res, `mencion-matricula-${matriculaId}.pdf`);
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 750);

  return true;
};

export const descargarMencionesHonorBatch = async (matriculaIds, modo = "TWO_UP", promocionId = null) => {
  const url = `${httpClient.baseUrl}${base}/batch/descargar?t=${Date.now()}`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      ...getAuthHeader(),
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
    body: JSON.stringify({ matricula_ids: matriculaIds, modo, promocion_id: promocionId }),
    cache: "no-store",
  });

  if (!res.ok) {
    let message = res.statusText || "No se pudo descargar las menciones.";
    const ct = res.headers.get("content-type") || "";
    try {
      if (ct.includes("application/json")) {
        const data = await res.json();
        if (data?.message) message = data.message;
      } else {
        const text = await res.text();
        if (text) message = text;
      }
    } catch {
      // ignore parse errors
    }
    const err = new Error(message);
    err.status = res.status;
    throw err;
  }

  const blob = await res.blob();
  const fallbackName = `menciones-${buildSafeName(Date.now())}.pdf`;
  const filename = getDownloadFilename(res, fallbackName);
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 750);

  return true;
};

const mencionesHonorService = {
  generarPorMatricula: generarMencionHonorPorMatricula,
  generarBatch: generarMencionesHonorBatch,
  descargarPorMatricula: descargarMencionHonorPorMatricula,
  descargarBatch: descargarMencionesHonorBatch,
};

export default mencionesHonorService;
